/** Справочник районов: город → районы → (необязательно) микрорайоны. */
export type DistrictDef = { name: string; neighborhoods?: readonly string[] };

export const DISTRICTS: Record<string, readonly DistrictDef[]> = {
  Анталья: [
    {
      name: "Коньяалты",
      neighborhoods: ["Хурма", "Лиман", "Сарысу", "Гюрсу", "Улучинар", "Алтынкум"],
    },
    { name: "Лара / Кунду" },
    { name: "Муратпаша (центр)" },
    { name: "Кепез" },
    { name: "Аксу" },
    { name: "Дошемеалты" },
    { name: "Белек" },
  ],
  Аланья: [
    "Центр",
    "Махмутлар",
    "Оба",
    "Тосмур",
    "Кестель",
    "Джикджилли",
    "Аванджылар",
    "Конаклы",
    "Каргыджак",
  ].map((name) => ({ name })),
  Кемер: ["Центр", "Бельдиби", "Гёйнюк", "Чамьюва", "Текирова"].map((name) => ({ name })),
};

/** Категории запросов, где показываем поле «Район». */
export const DISTRICT_REQUEST_CATEGORIES = [
  "Дружба и общение",
  "Дети и семья",
  "Мероприятия",
] as const;
/** Категории, где работает подбор людей рядом и кнопка «Позвать на кофе». */
export const NEIGHBOR_REQUEST_CATEGORIES = ["Дружба и общение", "Дети и семья"] as const;

export function districtsFor(city: string | null | undefined): readonly DistrictDef[] {
  return (city && DISTRICTS[city.trim()]) || [];
}

export function neighborhoodsFor(
  city: string | null | undefined,
  district: string | null | undefined,
): readonly string[] {
  return districtsFor(city).find((d) => d.name === district)?.neighborhoods ?? [];
}

/** «Анталья · Коньяалты · Хурма» — пустые части пропускаются. */
export function formatPlace(
  city?: string | null,
  district?: string | null,
  neighborhood?: string | null,
): string {
  return [city, district, neighborhood]
    .map((s) => s?.trim())
    .filter((s) => s && s !== "Не указан")
    .join(" · ");
}
